import React, { useMemo } from "react";

import "./styles.scss";
import { Row, Col } from "antd";
import uniqBy from "lodash/uniqBy";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Card from "shared/components/Card";
import Input from "shared/components/Input";
import More from "shared/components/More";
import Space from "shared/components/Space";
import { NAME_SPACES } from "shared/locals/constants";
import { useQueryParam, StringParam } from "use-query-params";
import { PATHS } from "utils/constants";

import NoData from "../NoData";

const Component = ({ data, onLoadMore, loading, count }) => {
  const history = useHistory();
  const [search, setSearch] = useQueryParam("search", StringParam);
  const { t } = useTranslation(NAME_SPACES.FILES);

  const { options, filtredData } = useMemo(() => {
    const result = data.reduce(
      (prev, item) => {
        const _options = Object.values(item)
          .filter(
            (value) =>
              typeof value === "string" &&
              value
                .toLocaleLowerCase()
                .includes((search || "").toLocaleLowerCase()) &&
              !value.toLocaleLowerCase().includes("http"),
          )
          .map((value) => ({ value }));

        return {
          filtredData:
            _options.length > 0
              ? [...prev.filtredData, item]
              : prev.filtredData,
          options: search
            ? uniqBy([...prev.options, ..._options], "value")
            : [],
        };
      },
      { options: [], filtredData: [] },
    );
    return result;
  }, [data, search]);

  return (
    <>
      <Row>
        <Col sm={24} xs={24}>
          <Input
            mode="autoComplete"
            placeholder={t("SEARCH")}
            options={options}
            value={search}
            onSelect={setSearch}
            onSearch={setSearch}
          />
        </Col>
      </Row>
      <Space h={24} />
      <div className={"items"}>
        {filtredData.map((folder) => (
          <Card
            key={`list:${folder.folderNum}`}
            onClick={() =>
              history.push(
                PATHS.FILE.ADVANCEMENT.replace(":id", folder.folderNum),
              )
            }
            data={folder}
          />
        ))}
      </div>
      {data.length < count && (
        <More onClick={onLoadMore} title={t("SHOW_MORE")} loading={loading} />
      )}
      {filtredData.length === 0 && <NoData />}
    </>
  );
};

Component.propTypes = {
  onLoadMore: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      folderNum: PropTypes.string.isRequired,
      productDesc: PropTypes.string.isRequired,
      creationDate: PropTypes.string.isRequired,
      statusDesc: PropTypes.string.isRequired,
      statusComment: PropTypes.string.isRequired,
      statusCode: PropTypes.string.isRequired,
      productPhoto: PropTypes.string.isRequired,
    }),
  ).isRequired,
  count: PropTypes.number.isRequired,
};

export default Component;
